import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon, _span, _span2, _ModalHeader, _ModalBody;
import React, { useState, useCallback } from 'react';
import { Button, ColoredBackground, Glyphicon, Modal, ModalHeader, ModalBody, ModalTitle } from 'reaxl';
import HomeServices from '../HomeServices';
const srpURLs = {
  testDrive: '/cars-for-sale/Used+Cars/?homeServices=TEST_DRIVE',
  vehicleDelivery: '/cars-for-sale/Used+Cars/?marketExtension=only',
  virtualTour: '/cars-for-sale/Used+Cars/?homeServices=VIRTUAL_TOUR'
};
const navigateToSrp = service => {
  global.location.assign(srpURLs[service]);
};
const getButton = service => {
  const handleClick = e => {
    navigateToSrp(service);
  };
  return {
    [service]: /*#__PURE__*/_jsx(Button, {
      block: true,
      bsStyle: "secondary",
      onClick: handleClick
    }, void 0, "Find Eligible Vehicles")
  };
};
const homeServices = {
  ...getButton('virtualTour'),
  ...getButton('testDrive'),
  ...getButton('vehicleDelivery')
};
const HomeServiceBanner = /*#__PURE__*/React.memo(_ref => {
  let {
    ...rest
  } = _ref;
  const [show, setShow] = useState(false);
  const showHideToggleCallback = useCallback(e => {
    setShow(!show);
  }, [show]);
  return /*#__PURE__*/React.createElement("div", rest, /*#__PURE__*/_jsx(ColoredBackground, {
    className: "display-flex flex-nowrap justify-content-center",
    uiContext: "accent",
    "data-cmp": "homeServiceBanner"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "text-center padding-vertical-1"
  }, void 0, _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    className: "padding-right-1",
    glyph: "info"
  })), _span || (_span = /*#__PURE__*/_jsx("span", {
    className: "text-bold"
  }, void 0, "Our Dealers' Response to COVID-19")), _span2 || (_span2 = /*#__PURE__*/_jsx("span", {
    className: "display-block display-sm-inline padding-horizontal-sm-2"
  }, void 0, "- Extraordinary Times Demand Extraordinary Service. -")), /*#__PURE__*/_jsx(Button, {
    bsStyle: "text-decorated",
    className: "display-block display-md-inline",
    onClick: showHideToggleCallback
  }, void 0, "Find out about Dealer Home Services"))), /*#__PURE__*/_jsx(Modal, {
    dialogClassName: "homeServiceModal",
    show: show,
    onHide: showHideToggleCallback,
    bsSize: "large"
  }, void 0, _ModalHeader || (_ModalHeader = /*#__PURE__*/_jsx(ModalHeader, {
    closeButton: true
  }, void 0, /*#__PURE__*/_jsx(ModalTitle, {
    className: "text-center text-size-600"
  }, void 0, "Dealer Home Services"))), _ModalBody || (_ModalBody = /*#__PURE__*/_jsx(ModalBody, {}, void 0, /*#__PURE__*/_jsx(HomeServices, {
    headingClassName: "text-center",
    contentClassName: "display-flex flex-column flex-sm-row",
    services: homeServices,
    showHeader: false
  })))));
});
export default HomeServiceBanner;